export default __webpack_public_path__ + "static/media/admingroup848.2a82a559.svg";